export const contentBlockStyle = {
    position: 'relative',
    outline: '1px solid #E0E0E0',
    borderRadius: '8px',
    paddingBottom: '10px',
    marginBottom: '20px',
    // overflow: 'hidden',
};
